export default {
    metrika: {
        id: 26812653
    },

    defaults: {
        hooks: {
            onready: function () {},
            onshare: function () {}
        },

        theme: {
            bare: false,
            copy: 'last',
            lang: 'ru',
            limit: false,
            nonce: '',
            moreButtonType: '',
            popupPosition: 'inner',
            popupDirection: 'bottom',
            colorScheme: 'normal',
            shape: 'normal',
            services: 'collections,vkontakte,facebook,twitter',
            size: 'm',
            useLinks: false,
            direction: 'horizontal'
        },

        i18n: {
            az: {
                shareButton: 'Paylaşmaq',
                copyLink: 'Əlaqə',
                pressToCopy: 'Press ctrl+C and Enter to copy'
            },
            be: {
                shareButton: 'Падзяліцца',
                copyLink: 'Cпасылка',
                pressToCopy: 'Press ctrl+C and Enter to copy'
            },
            en: {
                shareButton: 'Share',
                copyLink: 'Copy link',
                pressToCopy: 'Press ctrl+C and Enter to copy'
            },
            hy: {
                shareButton: 'Կիսվել',
                copyLink: 'Հղում',
                pressToCopy: 'Press ctrl+C and Enter to copy'
            },
            ka: {
                shareButton: 'Share',
                copyLink: 'ბმული',
                pressToCopy: 'Press ctrl+C and Enter to copy'
            },
            kk: {
                shareButton: 'Бөлісу',
                copyLink: 'Сілтеме',
                pressToCopy: 'Press ctrl+C and Enter to copy'
            },
            ro: {
                shareButton: 'Share',
                copyLink: 'Link',
                pressToCopy: 'Press ctrl+C and Enter to copy'
            },
            ru: {
                shareButton: 'Поделиться',
                copyLink: 'Скопировать ссылку',
                pressToCopy: 'Чтобы скопировать, нажмите ctrl+С и enter'
            },
            tr: {
                shareButton: 'Paylaş',
                copyLink: 'Bağlantı',
                pressToCopy: 'Press ctrl+C and Enter to copy'
            },
            tt: {
                shareButton: 'Уртаклашу',
                copyLink: 'Сылтама',
                pressToCopy: 'Press ctrl+C and Enter to copy'
            },
            uk: {
                shareButton: 'Поділитися',
                copyLink: 'Посилання',
                pressToCopy: 'Press ctrl+C and Enter to copy'
            },
            uz: {
                shareButton: 'Ulashish',
                copyLink: 'Havoladan nusxa olish',
                pressToCopy: 'Nusxa olish uchun ctrl+С va enter tugmalarini bosing'
            }
        },

        content: {
            template: 'default',
            description: '',
            image: '',
            title: window.document.title,
            url: window.location.href
        },

        contentByService: {}
    }
};
